import css from 'styled-jsx/css';

export default css`
  .content-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
  }
  @media (max-width: 767px) {
    .content-header {
      flex-direction: column;
      gap: 10px;
      padding: 0;
    }
  }
  .content-title-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  @media (max-width: 800px) {
    .content-title-wrapper {
      width: 100%;
    }
  }
  .content-title {
    margin: 0;
    padding: 0 0 10px 0;
    font-family: 'Eurostile-Bold';
    font-size: 40px;
  }
  @media (max-width: 767px) {
    .content-title {
      font-size: 36px;
      padding: 0;
    }
  }
`;
